import Vue from "vue";

/**
 * Function to remove duplicate emails
 *
 * @param originalEmailList
 * @param newEmailList
 * @returns {*}
 */
function removeDuplicate(originalEmailList, newEmailList) {
  return newEmailList.filter(newEmail => !originalEmailList.find(orgEmail => newEmail.mailBoxId === orgEmail.mailBoxId));
}

/**
 * Mutations for email
 */
export const mutations = {

  /**
   * Set the email list
   *
   * @param state
   * @param emailList
   * @param boxType
   */
  setEmails(state, {emailList, boxType, folderId}) {
    emailList = removeDuplicate('custom' === boxType ? state.emails[boxType][folderId].list :
      state.emails[boxType].list, emailList);

    if('custom' === boxType) {
      state.emails[boxType][folderId].list = state.emails[boxType][folderId].list.concat(emailList);
    } else {
      state.emails[boxType].list = state.emails[boxType].list.concat(emailList);
    }
  },

  /**
   * Mutation to add email to top of email list
   *
   * @param state
   * @param email
   * @param boxType
   * @param folderId
   */
  addNewEmailToEmailList(state, {email, boxType, folderId}) {
    if('custom' === boxType) {
      state.emails[boxType][folderId].list.splice(0, 0, email);
    } else {
      state.emails[boxType].list.splice(0, 0, email);
    }
  },

  /**
   * Function to reset the mail data
   *
   * @param state
   * @param boxType
   */
  resetEmails(state, {boxType, folderId}) {
    if('all' === boxType) {
      for (let boxType in state.emails) {
        if ('custom' === boxType) {
          state.emails[boxType] = {};
        } else {
          state.emails[boxType] = {
            list: [],
            page: 1,
            additionalOffset: 0,
            isFewPagesLoaded: false,
            isAllPagesLoaded: false,
            loading: false
          };
        }
      }
    } else {
      if ('custom' === boxType && state.emails[boxType][folderId]) {
        state.emails[boxType][folderId] = {
          list: [],
          page: 1,
          additionalOffset: 0,
          isFewPagesLoaded: false,
          isAllPagesLoaded: false,
          loading: false
        };
      } else {
        state.emails[boxType] = {
          list: [],
          page: 1,
          additionalOffset: 0,
          isFewPagesLoaded: false,
          isAllPagesLoaded: false,
          loading: false
        };
      }
    }
  },

  /**
   * Function to set the mail values for various keys
   *
   * @param state
   * @param boxType
   * @param key
   * @param value
   */
  setMailVal(state, {boxType, folderId, key, value}) {
    if((folderId > 0) && ('custom' === boxType)) {
      state.emails[boxType][folderId][key] = value;
    } else {
      state.emails[boxType][key] = value;
    }
  },

  /**
   * Creating new personal folder on state
   *
   * @param state
   * @param folderId
   */
  createNewPersonalFolder(state, folderId) {
    Vue.set(state.emails.custom, folderId, {
      list: [],
      page: 1,
      additionalOffset: 0,
      isFewPagesLoaded: false,
      isAllPagesLoaded: false,
      loading: false
    });
  },

  /**
   * Set the email folders
   *
   * @param state
   * @param emailFolder
   */
  setEmailFolder(state, emailFolder)  {
    state.emailFolder = emailFolder;
  },

  /**
   * Sets the favourite mode filter
   *
   * @param state
   * @param value
   */
  setFavouriteMode(state, value) {
    state.favouriteMode = value === true;
  },

  /**
   * Sets the selected custom folder name
   *
   * @param state
   * @param value
   */
  setSelectedCustomFolderName(state, value) {
    state.selectedCustomFolderName = value;
  },

  /**
   * Clear state when logging out
   *
   * @param {Object} state
   */
  clearState(state) {
    state.emailFolder = false;
    state.signatures = [];
    state.emails = {
      inbox: {
        list: [],
        page: 1,
        additionalOffset: 0,
        isFewPagesLoaded: false,
        isAllPagesLoaded: false,
        loading: false
      },
      sent: {
        list: [],
        page: 1,
        additionalOffset: 0,
        isFewPagesLoaded: false,
        isAllPagesLoaded: false,
        loading: false
      },
      unread: {
        list: [],
        page: 1,
        additionalOffset: 0,
        isFewPagesLoaded: false,
        isAllPagesLoaded: false,
        loading: false
      },
      custom: {
      },
      draft: {
        list: [],
        page: 1,
        additionalOffset: 0,
        isFewPagesLoaded: false,
        isAllPagesLoaded: false,
        loading: false
      },
      trash: {
        list: [],
        page: 1,
        additionalOffset: 0,
        isFewPagesLoaded: false,
        isAllPagesLoaded: false,
        loading: false
      }
    };
    state.unreadMailIds = [];
    state.favouriteMode = false;
    state.selectedCustomFolderName = null;
    state.initialMailDetail = null;
    state.composeEmailLoading = false;
    state.contactList = [];
    state.boxCount = {
      inbox: 0,
      unread: 0,
      needLoad: true
    };
  },

  /**
   * Sets initial mail details prior to loading component
   *
   * @param state
   * @param value
   */
  setInitialMailDetails(state, value) {
    state.initialMailDetail = value;
  },

  /**
   * Sets the loading parameter
   *
   * @param state
   * @param value
   */
  setComposeEmailLoading(state, value) {
    state.composeEmailLoading = value;
  },

  /**
   * Sets the contact list
   *
   * @param state
   * @param value
   */
  setContactList(state, value) {
    state.contactList = value;
  },

  /**
   * Sets the signature list
   *
   * @param state
   * @param value
   */
  setSignatures(state, value) {
    state.signatures = value;
  },

  /**
   * Sets favourite for a mailId
   *
   * @param state
   * @param mailId
   * @param boxType
   * @param folderId
   * @param isAdd
   */
  addRemoveFavourite(state, {mailId, boxType, folderId, isAdd}) {
    if(0 === folderId) {
      let mailIndex = -1;
      let mail = state.emails[boxType].list.find((mail, index) => {
        if(Number(mailId) === Number(mail.mailBoxId)) {
          mailIndex = index;
          return true;
        } else {
          return false;
        }
      });

      if(mail) {
        mail.isFavourite = 'serverReq' === isAdd ? isAdd : (isAdd ? '1' : '0');
        if(state.favouriteMode) {
          state.emails[boxType].list.splice(mailIndex, 1);
        }
      }
    } else {
      if(state.emails['custom'][folderId]) {
        let mailIndex = -1;
        let mail = state.emails['custom'][folderId].list.find((mail, index) => {
          if((Number(mailId) === Number(mail.mailBoxId)) && (Number(folderId) === Number(mail.folderId))) {
            mailIndex = index;
            return true;
          } else {
            return false;
          }
        });

        if(mail) {
          mail.isFavourite = 'serverReq' === isAdd ? isAdd : (isAdd ? '1' : '0');
          if(state.favouriteMode) {
            state.emails['custom'][folderId].list.splice(mailIndex, 1);
          }
        }
      }
    }

    if('unread' === boxType || 'inbox' === boxType || 'custom' === boxType) {
      let box = (('unread' === boxType) && (0 === folderId)) ? 'inbox' : 'unread';
      let mailIndex = -1;
      let mail = state.emails[box].list.find((mail, index) => {
        if(Number(mailId) === Number(mail.mailBoxId)) {
          mailIndex = index;
          return true;
        } else {
          return false;
        }
      });

      if (mail) {
        mail.isFavourite = 'serverReq' === isAdd ? isAdd : (isAdd ? '1' : '0');
        if(state.favouriteMode) {
          state.emails[box].list.splice(mailIndex, 1);
        }
      }
    }
  },

  /**
   * Marking the email as read
   *
   * @param state
   * @param mailId
   * @param boxType
   * @param folderId
   */
  markEmailAsRead(state, {mailId, boxType, folderId}) {
    let mail = null;
    if(0 === folderId) {
      let unreadMailIndex = -1;
      mail = state.emails[boxType].list.find((mail, index) => {
        if(Number(mailId) === Number(mail.mailBoxId)) {
          unreadMailIndex = index;
          return true;
        } else {
          return false;
        }
      });

      if (mail) {
        mail.readStatus = 1;
      }

      if('unread' === boxType && unreadMailIndex > -1) {
        state.emails[boxType].list.splice(unreadMailIndex, 1);
      }

    } else {
      if(state.emails['custom'][folderId]) {
        mail = state.emails['custom'][folderId].list.find((mail) => {
          return ((Number(mailId) === Number(mail.mailBoxId)) && (Number(folderId) === Number(mail.folderId)));
        });

        if (mail) {
          mail.readStatus = 1;
        }
      }
    }

    if('unread' === boxType || 'inbox' === boxType || 'custom' === boxType) {
      let box = (('unread' === boxType) && (0 === folderId)) ? 'inbox' : 'unread';
      let mailIndex = -1;
      let mail = state.emails[box].list.find((mail, index) => {
        if (Number(mailId) === Number(mail.mailBoxId)) {
          mailIndex = index;
          return true;
        } else {
          return false;
        }
      });

      if (mail && (mailIndex > -1)) {
        if('unread' === box) {
          state.emails.unread.list.splice(mailIndex, 1);
        } else {
          mail.readStatus = 1;
        }
      }
    }
  },

  /**
   * add items to unread mail ids
   *
   * @param state
   * @param mailId
   */
  addItemsToUnreadMails(state, {mailId, isIncreaseCount}) {
    let checkEmailId = state.unreadMailIds.includes(mailId);
    if(!checkEmailId) {
      state.unreadMailIds.splice(0, 0, mailId);
    }

    if(isIncreaseCount) {
      state.unreadMailCountOnOtherPage = state.unreadMailCountOnOtherPage + 1;
    }
  },

  /**
   * Function to increase the box count
   *
   * @param state
   * @param key
   */
  increaseBoxCount(state, {key}) {
    state.boxCount[key] += 1;
  },

  /**
   * Increases the unread mail count on other pages
   *
   * @param state
   */
  increaseUnreadMailCountOnOtherPage(state) {
    state.unreadMailCountOnOtherPage = state.unreadMailCountOnOtherPage + 1;
  },

  /**
   * remove item from unread mail ids
   *
   * @param state
   * @param mailId
   */
  removeItemFromUnreadMails(state, {mailId, decreaseCount}) {
    let mailIdIndex = state.unreadMailIds.indexOf(mailId);
    if(mailIdIndex > -1) {
      state.unreadMailIds.splice(mailIdIndex, 1);
      state.boxCount.unread = state.unreadMailIds.length;

      if(decreaseCount) {
        state.unreadMailCountOnOtherPage = state.boxCount.unread;
      }

    }

    /*if(decreaseCount) {
      state.unreadMailCountOnOtherPage = state.unreadMailCountOnOtherPage - 1;
    }*/
  },

  /**
   * Sets the unread mail ids
   *
   * @param state
   * @param mailIds
   */
  setUnreadMailIds(state, {mailIds, setForOtherPage}) {
    state.unreadMailIds = mailIds;
    if(setForOtherPage) {
      state.unreadMailCountOnOtherPage = mailIds.length;
    }
  },

  /**
   * Sets the box count
   *
   * @param state
   * @param key
   * @param value
   */
  setBoxCount(state, {key, value}) {
    state.boxCount[key] = value;
  },

  /**
   * Sets the selected user id
   *
   * @param state
   * @param id
   */
  setSelectedUserId(state, id) {
    state.selectedUserId = id;
  },

  /**
   * Sets the subscriber id
   *
   * @param state
   * @param subscriberId
   */
  setSubscriberId(state, subscriberId) {
    state.subscriberId = subscriberId;
  },

  /**
   * Sets the app users
   *
   * @param state
   * @param appUsers
   */
  setAppUsers(state, appUsers) {
    state.appUsers = appUsers;
  },

  /**
   * Clear state when logging out
   *
   * @param {Object} state
   */
  resetStateForOtherUser(state) {
    state.emailFolder = false;
    state.signatures = [];
    state.emails = {
      inbox: {
        list: [],
        page: 1,
        additionalOffset: 0,
        isFewPagesLoaded: false,
        isAllPagesLoaded: false,
        loading: false
      },
      sent: {
        list: [],
        page: 1,
        additionalOffset: 0,
        isFewPagesLoaded: false,
        isAllPagesLoaded: false,
        loading: false
      },
      unread: {
        list: [],
        page: 1,
        additionalOffset: 0,
        isFewPagesLoaded: false,
        isAllPagesLoaded: false,
        loading: false
      },
      custom: {
      },
      draft: {
        list: [],
        page: 1,
        additionalOffset: 0,
        isFewPagesLoaded: false,
        isAllPagesLoaded: false,
        loading: false
      },
      trash: {
        list: [],
        page: 1,
        additionalOffset: 0,
        isFewPagesLoaded: false,
        isAllPagesLoaded: false,
        loading: false
      }
    };
    state.favouriteMode = false;
    state.selectedCustomFolderName = null;
    state.initialMailDetail = null;
    state.composeEmailLoading = false;
    state.contactList = [];
    state.boxCount = {
      inbox: 0,
      unread: 0,
      needLoad: true
    };
  }
};
